import React from "react";
import { PageTitle, Paragraph, ParaImageDialog, ParaTitle, Pagination, CodeSnippet } from "../common";
import { Typography } from "@mui/material";

const ApproveEvents = () => {
  return (
    <div>
      <PageTitle title='Approve Events' role='Approver' />
      <ParaTitle paraTitle='My Approvals Tab' />
      <Paragraph paragraph='A Approver can either approve or reject an event. To approve an event, you must be logged in as an Approver.' />
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        Events pending to be approved can be found under the <CodeSnippet codeSnippet='My Approvals' /> tab. To see more information about the event, simply click on the event to go to the <CodeSnippet codeSnippet='Event Summary' /> page.
      </Typography>
      <ParaImageDialog src='/tutorial_image/approve-events-1.png' />

      <ParaTitle paraTitle='Approving An Event' />
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        From the <CodeSnippet codeSnippet='Event Summary' /> page, Approver can click on the <CodeSnippet codeSnippet='Actions' /> drop down to see 2 options available: Approve or Reject.
      </Typography>
      <Paragraph paragraph='To approve, simply select the Approve option.' />
      <ParaImageDialog src='/tutorial_image/approve-events-2.png' />
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        This action will changed the status of the event to <CodeSnippet codeSnippet='Closed' />  and remove the event from the  <CodeSnippet codeSnippet='My Approvals' /> tab. A confirmation notification can be seen if the event was successfully approved.
      </Typography>
      <ParaImageDialog src='/tutorial_image/approve-events-3.png' />

      <ParaTitle paraTitle='No Events Pending Approval' />
      <Typography variant="body1" component="div" sx={{ py: '5px' }}>
        If no more pending approval events are available, the <CodeSnippet codeSnippet='My Approvals' /> tab is removed and the <CodeSnippet codeSnippet='My Events' /> tab is the only tab available for the Approver.
      </Typography>
      <ParaImageDialog src='/tutorial_image/approve-events-4.png' />

      <Pagination
        pagination={{
          prev: { name: 'Complete Review', link: '/reviewer/complete-review' },
          next: { name: 'Change Facility', link: '/organization-manager/change-facility' }
        }}
      />
    </div>
  );
};

export default ApproveEvents;
